const getters = {
  applicationId(state) {
    return state.home?.application?.id || JSON.parse(localStorage.getItem('home'))?.application?.id;
  },
  applicationSubStatus(state) {
    return state.home?.application?.subStatus || JSON.parse(localStorage.getItem('home'))?.application?.subStatus;
  },
  applicationStatus(state) {
    return state.home?.application?.status.value || JSON.parse(localStorage.getItem('home'))?.application?.status.value;
  },
  skipVideoVerification(state) {
    return state.home?.skipVideoVerification || JSON.parse(localStorage.getItem('home'))?.skipVideoVerification;
  },
  videoVerificationSkipAllowedByUser(state) {
    return state.home?.videoVerificationSkipAllowedByUser || JSON.parse(localStorage.getItem('home'))?.videoVerificationSkipAllowedByUser;
  },
  videoVerified(state) {
    return state.home?.videoVerified || JSON.parse(localStorage.getItem('home'))?.videoVerified;
  },
  skipBusinessRegistration(state) {
    return state.home?.skipBusinessRegistration || JSON.parse(localStorage.getItem('home'))?.skipBusinessRegistration;
  },
  skipBusinessProfileInReferral(state) {
    return state.home?.skipBusinessProfileInReferral || JSON.parse(localStorage.getItem('home'))?.skipBusinessProfileInReferral;
  },
  mandateRegistered(state) {
    return state.home?.application?.mandateRegistered || JSON.parse(localStorage.getItem('home'))?.application?.mandateRegistered;
  },
  showHigherLimitBanner(state) {
    return state.home?.showHigherLimitBanner || JSON.parse(localStorage.getItem('home'))?.showHigherLimitBanner;
  },
  bestApprovedAmount(state) {
    return state.home?.bestApprovedAmount || JSON.parse(localStorage.getItem('home'))?.bestApprovedAmount;
  },
  digiLockerVerified(state) {
    return state.home?.application?.digiLockerVerified || JSON.parse(localStorage.getItem('home'))?.application?.digiLockerVerified;
  },
  applicationCompletionPercentage(state) {
    return state.home?.percentCompleted || JSON.parse(localStorage.getItem('home'))?.percentCompleted;
  },
  videoId(state) {
    return state.home?.videoId || JSON.parse(localStorage.getItem('home'))?.videoId;
  },
  partners(state) {
    return state.home?.partners || JSON.parse(localStorage.getItem('home'))?.partners;
  },
  latestLoanId(state) {
    if (state.latestLoanId) {
      return state.latestLoanId;
    }
    if (localStorage.getItem('latestLoanId')) {
      return localStorage.getItem('latestLoanId');
    }
    return state.home?.application?.latestLoanId || state.home?.creditAccountInfo?.loanId || JSON.parse(localStorage.getItem('home'))?.application?.latestLoanId || JSON.parse(localStorage.getItem('home'))?.creditAccountInfo?.loanId;
  },
  bankName(state) {
    return state.home?.application?.bankInfo?.ifscCode?.slice(0, 4) || JSON.parse(localStorage.getItem('home'))?.application?.bankInfo?.ifscCode?.slice(0, 4);
  },
  ifscCode(state) {
    return state.home?.application?.bankInfo?.ifscCode || JSON.parse(localStorage.getItem('home'))?.application?.bankInfo?.ifscCode;
  },
  uuid(state) {
    return state.home?.customer?.uuid || JSON.parse(localStorage.getItem('home'))?.customer?.uuid;
  },
  bannerButtonText(state) {
    return state.home?.application?.status?.bannerButtonText || JSON.parse(localStorage.getItem('home'))?.application?.status?.bannerButtonText;
  },
  creditAccountInfo(state) {
    return state.home?.creditAccountInfo || JSON.parse(localStorage.getItem('home'))?.creditAccountInfo;
  },
  showCreditCard() {
    return false;
    // return state.home?.showCreditCard;
  },
  commentsAvailable(state) {
    return state.home?.commentsAvailable || JSON.parse(localStorage.getItem('home'))?.commentsAvailable;
  },
  applicationRejected(state) {
    return state.home?.application?.applicationRejected || JSON.parse(localStorage.getItem('home'))?.application?.applicationRejected;
  },
  webApprovalBuySectionImage(state) {
    return state.home?.webApprovalBuySectionImage || JSON.parse(localStorage.getItem('home'))?.webApprovalBuySectionImage;
  },
  webRejectionBuySectionImage(state) {
    return state.home?.webRejectionBuySectionImage || JSON.parse(localStorage.getItem('home'))?.webRejectionBuySectionImage;
  },
  referAndEarnTncLink(state) {
    return state.home?.referAndEarnTncLink || JSON.parse(localStorage.getItem('home'))?.referAndEarnTncLink;
  },
  cardKycStatus(state) {
    return state.home?.cards.find(card => card.kycStatus === 'fullKyc') || JSON.parse(localStorage.getItem('home'))?.cards.find(card => card.kycStatus === 'fullKyc') ? 'fullKyc' : undefined;
  },
  nextAction(state) {
    return state.home?.application?.nextAction || JSON.parse(localStorage.getItem('home'))?.application?.nextAction;
  },
  reKycStatus(state) {
    return state.reKycStatus || JSON.parse(localStorage.getItem('reKycStatus'));
  },
  esignUrl(state) {
    return state.home?.esignUrl || JSON.parse(localStorage.getItem('home'))?.esignUrl;
  },
  processingFeeDetail(state) {
    return state.home?.processingFeeDetails || JSON.parse(localStorage.getItem('home'))?.processingFeeDetails;
  },
  guarantorDetailsData(state) {
    return state.home?.guarantorDetails || JSON.parse(localStorage.getItem('home'))?.guarantorDetails;
  },
};
export default getters;
